(function () {
  var CFG = window.GLOBO_POPUP_GUARD || {
    formId: 128306,
    frequency: 'day', // 'day' | 'session'
    blockTag: '',
    key: 'globo_popup_guard_128306'
  };

  function getS(s, k) { try { return s.getItem(k); } catch (e) { return null; } }
  function setS(s, k, v) { try { s.setItem(k, v); } catch (e) {} }

  function hasTag() {
    if (!CFG.blockTag) return false;
    var t = window.__customerTags || [];
    for (var i = 0; i < t.length; i++) if (t[i] === CFG.blockTag) return true;
    return false;
  }

  function blockedByFreq() {
    if (CFG.frequency === 'session') return !!getS(sessionStorage, CFG.key);
    var ts = parseInt(getS(localStorage, CFG.key) || '0', 10);
    return ts && !isNaN(ts) && (Date.now() - ts) < 86400000;
  }

  function isBlocked() { return hasTag() || blockedByFreq(); }

  function markOpened() {
    if (CFG.frequency === 'session') setS(sessionStorage, CFG.key, '1');
    else setS(localStorage, CFG.key, String(Date.now()));
  }

  function isTarget(el) {
    if (!el) return false;
    if (!CFG.formId) return true;
    if (String(el.getAttribute('data-id') || '') === String(CFG.formId)) return true;
    return !!(el.closest('.globo-form-id-' + CFG.formId) || el.closest('#globo-formbuilder-' + CFG.formId));
  }

  function onScreen(el) {
    if (!el) return false;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;

    var cs = window.getComputedStyle ? getComputedStyle(el) : null;
    if (cs && (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') < 0.05 || cs.pointerEvents === 'none')) return false;

    var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    if (!r || r.width < 10 || r.height < 10) return false;

    var vw = window.innerWidth || document.documentElement.clientWidth || 0;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;

    if (!(r.bottom > 0 && r.right > 0 && r.top < vh && r.left < vw)) return false;

    var w = Math.min(r.right, vw) - Math.max(r.left, 0);
    var h = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return w >= 30 && h >= 30;
  }

  function hide(el) {
    try {
      el.classList.remove('active');
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');

      var modal = el.closest('.globo-form-publish-modal');
      if (modal) modal.style.setProperty('display', 'none', 'important');

      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    } catch (e) {}
  }

  function getActive() {
    var list = document.querySelectorAll('.globo-form-app.active');
    for (var i = 0; i < list.length; i++) if (isTarget(list[i])) return list[i];
    return null;
  }

  var allowUntilClosed = false;
  var markTimer = null;

  function tick() {
    var a = getActive();

    if (!a) {
      allowUntilClosed = false;
      if (markTimer) { clearTimeout(markTimer); markTimer = null; }
      return;
    }

    if (!allowUntilClosed) {
      if (isBlocked()) { if (markTimer) { clearTimeout(markTimer); markTimer = null; } hide(a); return; }
      allowUntilClosed = true;
    }

    if (!blockedByFreq() && onScreen(a)) {
      if (!markTimer) {
        markTimer = setTimeout(function () {
          markTimer = null;
          var cur = getActive();
          if (cur && allowUntilClosed && !hasTag() && !blockedByFreq() && onScreen(cur)) markOpened();
        }, 300);
      }
    } else if (markTimer) {
      clearTimeout(markTimer); markTimer = null;
    }
  }

var scheduled = false;

var mo = new MutationObserver(function () {
  if (scheduled) return;
  scheduled = true;

  (window.requestAnimationFrame || function (cb) { setTimeout(cb, 0); })(function () {
    scheduled = false;
    tick();
  });
});

mo.observe(document.documentElement, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['class', 'style']
});


  function patch() {
    if (!window.Globo || !window.Globo.FormBuilder) return false;
    var fb = window.Globo.FormBuilder;
    if (fb.__popupGuardPatched) return true;

    var m = ['openModalForm','openModalFormButton','showFloatingForm','openPopupForm','openPopupFormButton','showPopupForm','openForm','showForm'];
    window.__globoOriginals = window.__globoOriginals || {};

    for (var i = 0; i < m.length; i++) (function (name) {
      if (typeof fb[name] !== 'function') return;
      if (!window.__globoOriginals[name]) window.__globoOriginals[name] = fb[name];
      fb[name] = function () { if (isBlocked()) return; return window.__globoOriginals[name].apply(this, arguments); };
    })(m[i]);

    fb.__popupGuardPatched = true;
    return true;
  }

  var tries = 0;
  var t = setInterval(function () {
    tries++;
    if (patch()) clearInterval(t);
    else if (tries > 400) clearInterval(t);
  }, 25);
})();
